const getVehicleBrandImage = function(logo, size=3) {
	return {
		'display': 'inline-block',
		'width': size + 'rem',
		'height': size + 'rem',
		'background-repeat': 'no-repeat',
		'background-position': 'center',
		'background-size': 'contain',
		'background-image': 'url( ' + getPublicImageUrl(logo) + ')'
	}
};

const getPublicImageUrl = function(path) {
	if (path.startsWith('http')) {
		return path;
	}
	return process.env.API_BASE_URL + path;
};

export default {
	vehicleBrandImage: getVehicleBrandImage
};


// WEBPACK FOOTER //
// ./src/tools/images.js